import { HStack, VStack, Box, Button, Flex, Select } from '@chakra-ui/react'
import { FC } from 'react'
import {
  IPadding,
  ISectionColumnsVideo,
  IVideo,
  IVideoPlatform
} from 'shared/types'
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult
} from 'react-beautiful-dnd'
import map from 'lodash/map'
import { ReactComponent as IconX } from 'shared/assets/bsXCircle.svg'
import { ReactComponent as IconList } from 'shared/assets/bsList.svg'
import { arrayMove } from 'shared/utils/array'
import Label from 'shared/components/Label'
import VideoField from 'components/formFields/VideoField'
import VideoPlayer from 'shared/components/VideoPlayer'
import VideoPlatformSelect from 'components/VideoPlatformSelect'
import PaddingSelect from 'components/PaddingSelect'

type Props = {
  s: ISectionColumnsVideo
  onChange: (s: ISectionColumnsVideo) => void
}

const EditSectionColumnsVideo: FC<Props> = ({ s, onChange }) => {
  const onDragEnd = (result: DropResult) => {
    console.log('onDragEnd', result)
    if (result.destination && result.destination.index >= 0) {
      const columns = arrayMove(
        s.columns,
        result.source.index,
        result.destination?.index || 0
      )
      onChange({ ...s, columns })
    }
  }

  const onRemove = (i: number) => {
    console.log('onRemove', i)
    const columns = [...(s.columns || [])]
    columns.splice(i, 1)
    onChange({ ...s, columns })
  }

  const addCard = () => {
    const p: IVideo = {
      platform: IVideoPlatform.VIMEO,
      url: ''
    }
    const columns = [...(s.columns || []), p]
    onChange({ ...s, columns })
  }

  const onChangeVideoUrl = (v: string, i: number) => {
    const columns = [...s.columns]
    columns[i] = { url: v, platform: columns[i].platform }
    onChange({ ...s, columns })
  }

  const onChangeVideoPlatform = (v: IVideoPlatform, i: number) => {
    const columns = [...s.columns]
    columns[i] = { url: '', platform: v }
    onChange({ ...s, columns })
  }

  const renderCard = (p: IVideo, i: number, isDraggable: boolean) => {
    if (isDraggable) {
      return (
        <Draggable key={i} draggableId={'card' + i} index={i}>
          {(provided, snapshot) => (
            <HStack
              borderWidth={1}
              borderColor='wood.600'
              px={2}
              w='full'
              // h={{ base: 6, lg: 8 }}
              rounded='4px'
              flexShrink={0}
              align='center'
              justify={'space-between'}
              color='wood.600'
              textStyle={{ base: 'tag', lg: 'small' }}
              ref={provided.innerRef}
              {...provided.draggableProps}
            >
              <Box {...provided.dragHandleProps}>
                <IconList width='14' height='14' />
              </Box>
              <VStack w='full' spacing={1}>
                <VideoPlatformSelect
                  value={p.platform}
                  onChange={(v: IVideoPlatform) => onChangeVideoPlatform(v, i)}
                />
                <VideoField
                  label=''
                  platform={p.platform}
                  value={p.url}
                  onChange={(v: string) => onChangeVideoUrl(v, i)}
                />
              </VStack>
              <Box
                textStyle={{ base: 'tag', lg: 'small' }}
                as='button'
                onClick={() => onRemove(i)}
                color='red.700'
              >
                <IconX width='14' height='14' />
              </Box>
            </HStack>
          )}
        </Draggable>
      )
    } else {
      return (
        <HStack
          borderWidth={1}
          borderColor='wood.600'
          px={2}
          w='full'
          // h={{ base: 6, lg: 8 }}
          rounded='4px'
          flexShrink={0}
          align='center'
          justify={'space-between'}
          color='wood.600'
          textStyle={{ base: 'tag', lg: 'small' }}
        >
          <VideoPlayer v={p} />
        </HStack>
      )
    }
  }

  const renderAddCard = () => {
    return (
      <VStack w={'full'}>
        <Button
          variant={'ghost'}
          size='sm'
          colorScheme='wood'
          onClick={addCard}
        >
          + Добавить карточку
        </Button>
      </VStack>
    )
  }

  const renderCards = () => {
    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable
          droppableId='tags'
          renderClone={(provided, snapshot, rubric) => {
            return (
              <div ref={provided.innerRef} {...provided.draggableProps}>
                {renderCard(s.columns[rubric.source.index], 0, false)}
              </div>
            )
          }}
        >
          {(provided, snapshot) => (
            <VStack
              w='full'
              direction={'column'}
              align='flex-start'
              textStyle='body'
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {map(s.columns, (p, i) => renderCard(p, i, true))}
              {provided.placeholder}
            </VStack>
          )}
        </Droppable>
      </DragDropContext>
    )
  }

  const renderCardsPerRow = () => {
    return (
      <HStack w='full' align='center' spacing={2} justify={'space-between'}>
        <Label>Количество колонок</Label>
        <Flex>
          <Select
            value={s.columnsAmount || 4}
            onChange={e =>
              onChange({ ...s, columnsAmount: Number(e.target.value) })
            }
            variant={'solid'}
            size='xs'
          >
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
          </Select>
        </Flex>
      </HStack>
    )
  }

  const renderPadding = () => {
    return (
      <PaddingSelect
        value={s.paddingTop}
        onChange={(v: IPadding) => onChange({ ...s, paddingTop: v })}
      />
    )
  }

  return (
    <VStack align='flex-start' w='full' spacing={6}>
      {renderPadding()}
      {renderCardsPerRow()}
      <VStack w='full'>
        {renderCards()}
        {renderAddCard()}
      </VStack>
    </VStack>
  )
}

export default EditSectionColumnsVideo
